import { render, staticRenderFns } from "./CardWallets.vue?vue&type=template&id=50f99410&scoped=true&"
import script from "./CardWallets.vue?vue&type=script&lang=js&"
export * from "./CardWallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f99410",
  null
  
)

export default component.exports